export function getPeriodFromInvoiceDescription(invoice) {
  const {lines} = invoice;

  return lines?.data?.length > 0 ? lines.data[0]?.period : {};
}
